<template>
    <Toast />
    <form @submit.prevent>
        <div id="page-container">
            <div id="header-wrap" style="font-size: 30px; font-weight: 700; line-height: 48px; text-align: center">Get a
                Quote</div>
            <div id="content-wrap">
                <div class="p-grid">
                    <div class="p-col-12">
                        <p class="subTitle1">Fill out this form in about 5 mins to get an accurate Air or Ocean Quote. We
                            will get back to you no later than next business day.</p>
                    </div>
                    <div class="p-col-12">
                        <p class="subTitle2">*Commercial Cargo only. By submitting this inquiry you are declaring you
                            possess all the related proper export/import licenses. Personal Effects/Household Goods are not
                            accepted at this moment.</p>
                    </div>
                    <div class="p-col-12">
                        <div class="SubjectLable MyDimerco-OpenSansBold">What are your cargo details and service
                            requirements?</div>
                    </div>
                    <div class="p-col-12">
                        <div class="card">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-6">
                                    <label :class="{ inValidate: Validate.isCargoReadyDateInValidate }"
                                        for="cargoReadyDate">Cargo Ready Date <span style="color: #f68b39">*</span></label>
                                    <Calendar @blur="checkRequired" @date-select="checkRequired"
                                        v-model="Quote.cargoReadyDate" inputId="cargoReadyDate" :showIcon="true"
                                        :minDate="minDate" dateFormat="yy-mm-dd" />
                                </div>
                                <div class="p-field p-col-12">
                                    <h5>Select a Mode</h5>
                                    <span class="selectModeDescription">Please select only one transportation mode and fill
                                        out the required information</span>
                                    <div>
                                        <Button label="AIR" id="AIR" icon="" class="p-mr-2 p-mb-2 p-mt-4"
                                            :class="{ shipmentTypeButton: !isAirSelected, shipmentTypeButtonSelected: isAirSelected }"
                                            @click.prevent="selectedShipmentType($event, 'AIR')"></Button>
                                        <Button label="LCL" id="LCL" icon="" class="p-mr-2 p-mb-2 p-mt-4"
                                            :class="{ shipmentTypeButton: !isLCLSelected, shipmentTypeButtonSelected: isLCLSelected }"
                                            @click.prevent="selectedShipmentType($event, 'LCL')"></Button>
                                        <Button label="FCL" id="FCL" icon="" class="p-mr-2 p-mb-2 p-mt-4"
                                            :class="{ shipmentTypeButton: !isFCLSelected, shipmentTypeButtonSelected: isFCLSelected }"
                                            @click.prevent="selectedShipmentType($event, 'FCL')"></Button>
                                    </div>
                                </div>
                                <div v-if="isAirSelected || isLCLSelected" class="p-field p-col-12">
                                    <div class="p-field-radiobutton">
                                        <RadioButton id="isCargoDetail" @change="checkRequired(); recalculateAll();"
                                            name="option" value="0" v-model="Quote.cargoDataType" />
                                        <label for="isCargoDetail">Cargo Detail</label>
                                        <RadioButton id="isTotal" name="option" @change="checkRequired(); recalculateAll();"
                                            value="1" v-model="Quote.cargoDataType" style="margin-left: 1.5rem" />
                                        <label for="isTotal">Total</label>
                                    </div>
                                </div>
                                <div v-if="(isAirSelected || isLCLSelected) && Quote.cargoDataType === '0'"
                                    class="p-field p-col-12">
                                    <div v-for="(item, index) in Quote.CargoDetailList" :key="index"
                                        class="p-fluid p-formgrid p-grid"
                                        style="background-color: #e7eef1 !important; margin-bottom: 5px; padding-top: 10px">
                                        <div class="p-field p-col-12 p-md-5">
                                            <label :class="{ inValidate: item.cargoDescriptValidate }"
                                                for="cd_cargoDescription">Cargo Description (Commodity)<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputText id="cd_cargoDescription" @change="checkRequired"
                                                v-model="item.cargoDescript" type="text" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="cd_HSCode">HS Code</label>
                                            <InputText id="cd_HSCode" v-model="item.hsCode" type="text" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label :class="{ inValidate: item.QTYValidate }" for="cd_QTY">QTY<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="cd_QTY" @input="
                                                item.QTY = $event.value;
                                            recalculateCargoDetail(item);
                                            " v-model="item.QTY" :min="0" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label :class="{ inValidate: item.TypeValidate }" for="cd_Type">Type<span
                                                    style="color: #f68b39">*</span></label>
                                            <Dropdown v-model="item.Type.eValue" :options="dropdownlistSource.quantityUnit"
                                                optionLabel="eName" optionValue="eValue" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-1">
                                            <Button v-if="Quote.CargoDetailList.length > 1" icon="pi pi-times"
                                                @click="removeItem(item.detailItemID)"
                                                class="p-button-rounded p-button-danger p-button-text" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label :class="{ inValidate: item.LValidate }" for="cd_L">L<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="cd_L" v-model="item.L" @input="
                                                item.L = $event.value;
                                            recalculateCargoDetail(item);
                                            " mode="decimal" :minFractionDigits="2" :maxFractionDigits="3" :min="0" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label :class="{ inValidate: item.WValidate }" for="cd_W">W<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="cd_W" v-model="item.W" @input="
                                                item.W = $event.value;
                                            recalculateCargoDetail(item);
                                            " mode="decimal" :minFractionDigits="2" :maxFractionDigits="3" :min="0" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label :class="{ inValidate: item.HValidate }" for="cd_H">H<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="cd_H" v-model="item.H" @input="
                                                item.H = $event.value;
                                            recalculateCargoDetail(item);
                                            " mode="decimal" :minFractionDigits="2" :maxFractionDigits="3" :min="0" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2" style="width: 8rem">
                                            <label for="cd_Weight_Unit">&nbsp;</label>
                                            <Dropdown v-model="item.unit.eValue" :options="dropdownlistSource.lengthUnit"
                                                @change="changeCargoDetailCubicUOM" optionLabel="eName"
                                                optionValue="eValue" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2" style="width: 13rem">
                                            <label :class="{ inValidate: item.weightValidate }" for="cd_Weight">Weight (per
                                                unit)<span style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="cd_Weight" v-model="item.weight" @input="
                                                item.weight = $event.value;
                                            recalculateCargoDetail(item);
                                            " mode="decimal" :minFractionDigits="2" :maxFractionDigits="3" :min="0" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-1" style="width: 8rem">
                                            <label for="cd_Weight_Unit">&nbsp;</label>
                                            <Dropdown @change="changeCargoDetailVolumnUOM"
                                                v-model="item.weightPreUnit.eValue" :options="dropdownlistSource.weightUnit"
                                                optionLabel="eName" optionValue="eValue" />
                                        </div>
                                        <!-- <div v-if="CargoDetails.length > 1" class="p-field p-col-12 p-md-1"></div> -->
                                        <div style="text-align: end" class="p-field p-col-12 p-md-12">Subtotal {{
                                            numberToCurrencyNo(item.subTotalCBM) }}
                                            {{ displayText.cargoDetailSubTotalCubicUOM }} {{
                                                numberToCurrencyNo(item.subTotalWeight) }}
                                            {{ displayText.cargoDetailSubTotalVolumeUOM }}</div>
                                    </div>
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-4 p-mt-4 p-pl-0">
                                            <Button label="Add More Cargo Item" icon="pi pi-plus"
                                                @click="AppendNewCargoDetail"
                                                style="background-color: #f68b39 !important; border: 1px solid #f68b39 !important; width: 15rem" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="(isAirSelected || isLCLSelected) && Quote.cargoDataType === '1'"
                                    class="p-field p-col-12">
                                    <div class="p-fluid p-formgrid p-grid"
                                        style="background-color: #e7eef1 !important;padding-top: 10px;">
                                        <div class="p-field p-col-12 p-md-2">
                                            <label :class="{ inValidate: Validate.isTotalItemQTYInValidate }"
                                                for="tt_Quantity">Quantity<span style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="tt_Quantity" @input="
                                                Quote.TotalItem.QTY = $event.value;
                                            recalculateAll(); checkRequired();
                                            " :min="0" v-model="Quote.TotalItem.QTY" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-3">
                                            <label :class="{ inValidate: Validate.isTotalItemTotalWeightInValidate }"
                                                for="tt_TotalWeight">Total Weight<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="tt_TotalWeight" @input="
                                                Quote.TotalItem.totalWeight = $event.value;
                                            recalculateAll(); checkRequired();
                                            " :min="0" v-model="Quote.TotalItem.totalWeight" mode="decimal"
                                                :minFractionDigits="2" :maxFractionDigits="3" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="tt_Weight_Unit">&nbsp;</label>
                                            <Dropdown @change="changeCargoDetailTotalVolumnUOM"
                                                v-model="Quote.TotalItem.totalWeightUnit.eValue"
                                                :options="dropdownlistSource.weightUnit" optionLabel="eName"
                                                optionValue="eValue" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-3">
                                            <label :class="{ inValidate: Validate.isTotalItemTotalVolumeInValidate }"
                                                for="tt_TotalVolume">Total Volume<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputNumber inputId="tt_TotalVolume" @input="
                                                Quote.TotalItem.totalVolume = $event.value;
                                            recalculateAll(); checkRequired();
                                            " :min="0" v-model="Quote.TotalItem.totalVolume" mode="decimal"
                                                :minFractionDigits="2" :maxFractionDigits="3" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="tt_Volume_Unit">&nbsp;</label>
                                            <Dropdown @change="changeCargoDetailTotalCubicUOM"
                                                v-model="Quote.TotalItem.totalVolumUnit.eValue"
                                                :options="dropdownlistSource.volumeUnit" optionLabel="eName"
                                                optionValue="eValue" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <label :class="{ inValidate: Validate.isTotalItemCargoDescriptionInValidate }"
                                                for="tt_cargoDescription">Cargo Description (Commodity)<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputText id="tt_cargoDescription" @change="checkRequired" type="text"
                                                v-model="Quote.TotalItem.caegoDescription" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <label for="tt_HSCode">HS Code</label>
                                            <InputText id="tt_HSCode" type="text" v-model="Quote.TotalItem.hsCode" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="isFCLSelected" class="p-field p-col-12">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-3"><img style="width: 196px"
                                                src="assets/images/media/TYPE_20.jpg" alt="diamond-layout" /></div>
                                        <div class="p-field p-col-3"><img style="width: 196px"
                                                src="assets/images/media/TYPE_40.jpg" alt="diamond-layout" /></div>
                                        <div class="p-field p-col-3"><img style="width: 196px"
                                                src="assets/images/media/TYPE_40_HC.jpg" alt="diamond-layout" /></div>
                                        <div class="p-field p-col-3"><img style="width: 196px"
                                                src="assets/images/media/TYPE_45_HC.jpg" alt="diamond-layout" /></div>

                                        <div class="p-field p-col-3"
                                            style="text-align: center; font-weight: bold; font-size: 26px">20'</div>
                                        <div class="p-field p-col-3"
                                            style="text-align: center; font-weight: bold; font-size: 26px">40'</div>
                                        <div class="p-field p-col-3"
                                            style="text-align: center; font-weight: bold; font-size: 26px">40'HC</div>
                                        <div class="p-field p-col-3"
                                            style="text-align: center; font-weight: bold; font-size: 26px">45'HC</div>

                                        <div class="p-field p-col-12 p-md-3">
                                            <label for="standardTwenty">Standard</label>
                                            <InputNumber inputId="standardTwenty" @input="
                                                Quote.FCLItem.standardTwenty = $event.value;
                                            recalculateAll();
                                            " :min="0" :useGrouping="false" v-model="Quote.FCLItem.standardTwenty" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-3">
                                            <label for="standardForty">Standard</label>
                                            <InputNumber inputId="standardForty" @input="
                                                Quote.FCLItem.standardForty = $event.value;
                                            recalculateAll();
                                            " :min="0" :useGrouping="false" v-model="Quote.FCLItem.standardForty" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-3">
                                            <label for="standardFortyHC">Standard</label>
                                            <InputNumber inputId="standardFortyHC" @input="
                                                Quote.FCLItem.standardFortyHC = $event.value;
                                            recalculateAll();
                                            " :min="0" :useGrouping="false" v-model="Quote.FCLItem.standardFortyHC" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-3">
                                            <label for="standardFortyFiveHC">Standard</label>
                                            <InputNumber inputId="standardFortyFiveHC" @input="
                                                Quote.FCLItem.standardFortyFiveHC = $event.value;
                                            recalculateAll();
                                            " :min="0" :useGrouping="false"
                                                v-model="Quote.FCLItem.standardFortyFiveHC" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <label :class="{ inValidate: Validate.isFLCcargoDescriptionInValidate }"
                                                for="cargoDescription">Cargo Description (Commodity)<span
                                                    style="color: #f68b39">*</span></label>
                                            <InputText id="cargoDescription" @change="checkRequired" type="text"
                                                v-model="Quote.FCLItem.caegoDescription" />
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <label for="hsCode">HS Code</label>
                                            <InputText id="hsCode" type="text" v-model="Quote.FCLItem.hsCode" />
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12">
                                    <h5>Upload your shipment documents here</h5>
                                    <FileUpload name="cargoDetailFiles[]" :auto="true" :customUpload="true"
                                        @uploader="CargoFileUpload" :multiple="true"
                                        accept=".docx,.pptx,.ppt,.pdf,.dot,.doc,.tif,.pjp,.apng,.xbm,.jxl,.svgz,.jpg,.jpeg,.ico,.tiff,.gif,.svg,.jfif,.webp,.png,.bmp,.pjpeg,.avif,.xlsx,.xls,.csv"
                                        :maxFileSize="5000000" :showUploadButton="false"
                                        @clear="CargoFileRemove('CargoDetail')">
                                        <template #empty>
                                            <p>Drag and drop files to here to upload.</p>
                                        </template>
                                    </FileUpload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="SubjectLable">Where are you shipping from and to?</div>
                    </div>
                    <div class="p-col-12">
                        <div class="card" style="padding-top:2rem;">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-6">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-12">
                                            <span class="p-float-label">
                                                <AutoComplete @change="checkRequired" @item-select="checkRequired"
                                                    @blur="checkRequired" id="origin"
                                                    v-model="Quote.shippingData.originItem.origin"
                                                    :suggestions="dropdownlistSource.originPort"
                                                    @complete="searchPort($event, 'Origin')" field="eName" />
                                                <label :class="{ inValidate: Validate.origin }" for="origin">Origin<span
                                                        style="color: #f68b39">*</span></label>
                                            </span>
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <div class="field-checkbox">
                                                <Checkbox @change="checkRequired" inputId="originCkb" class="p-mr-2"
                                                    v-model="Quote.shippingData.originItem.originPickupService"
                                                    :binary="true" />
                                                <label for="originCkb">Origin Pickup Service</label>
                                            </div>
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <div v-if="Quote.mode != 'AIR'" class="field-checkbox">
                                                <Checkbox inputId="stuffingServiceCkb" class="p-mr-2"
                                                    v-model="Quote.shippingData.originItem.stuffingService"
                                                    :binary="true" />
                                                <label for="stuffingServiceCkb">Stuffing Service</label>
                                            </div>
                                        </div>
                                        <div v-if="Quote.shippingData.originItem.originPickupService"
                                            class="p-field p-col-12 p-md-12">
                                            <div class="p-fluid p-formgrid p-grid">
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label :class="{ inValidate: Validate.OriginCountry }"
                                                        for="countryName">Country / Area<span
                                                            style="color: #f68b39">*</span></label>
                                                    <AutoComplete @change="checkRequired" id="shippingCountryName"
                                                        @blur="checkRequired"
                                                        v-model="Quote.shippingData.originItem.country" :dropdown="true"
                                                        :suggestions="dropdownlistSource.origin.country"
                                                        @item-select="getChildSource($event, 'ShippingOriginCountry')"
                                                        @complete="SearchAutoComplete($event, 'ShippingOriginCountry')"
                                                        field="eName" />
                                                </div>
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label :class="{ inValidate: Validate.OriginZipCode }"
                                                        for="zipPostalCode">Zip / Postal Code<span
                                                            style="color: #f68b39">*</span></label>
                                                    <InputText id="zipPostalCode" @change="checkRequired" type="text"
                                                        v-model="Quote.shippingData.originItem.zipCode" />
                                                </div>
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label :class="{ inValidate: Validate.OriginCity }"
                                                        for="cityName">City<span style="color: #f68b39">*</span></label>
                                                    <AutoComplete @change="checkRequired" id="shippingCityName"
                                                        @blur="checkRequired" v-model="Quote.shippingData.originItem.city"
                                                        :dropdown="true" :suggestions="dropdownlistSource.origin.city"
                                                        @item-select="getChildSource($event, 'ShippingOriginCity')"
                                                        @complete="SearchAutoComplete($event, 'ShippingOriginCity')"
                                                        field="eName" />
                                                </div>
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label for="stateProvince">State / Province</label>
                                                    <InputText id="stateProvince" type="text"
                                                        v-model="Quote.shippingData.originItem.state.eName" />
                                                </div>
                                                <div class="p-field p-col-12">
                                                    <label :class="{ inValidate: Validate.OriginAddress }"
                                                        for="address">Address<span style="color: #f68b39">*</span></label>
                                                    <InputText id="address" @change="checkRequired" type="text"
                                                        v-model="Quote.shippingData.originItem.address" :maxlength="500" />
                                                </div>
                                                <div class="p-field p-col-12">
                                                    <span>Special Instructions (Origin)</span>
                                                </div>
                                                <div class="p-field p-col-12 p-md-12">
                                                    <div class="field-checkbox">
                                                        <Checkbox inputId="nonRegularCkb" class="p-mr-2"
                                                            v-model="Quote.shippingData.originItem.nonRegularDeliveryService"
                                                            :binary="true" />
                                                        <label for="nonRegularCkb">Non-regular delivery service (By
                                                            appointment Only)</label>
                                                    </div>
                                                </div>
                                                <div class="p-field p-col-12 p-md-12">
                                                    <div class="field-checkbox">
                                                        <Checkbox inputId="noLoadingCkb" class="p-mr-2"
                                                            v-model="Quote.shippingData.originItem.noLoadingDockHandCarry"
                                                            :binary="true" />
                                                        <label for="noLoadingCkb">No loading dock / hand carry-in
                                                            delivery</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-12">
                                            <span class="p-float-label">
                                                <AutoComplete @change="checkRequired" id="destination" @blur="checkRequired"
                                                    @item-select="checkRequired"
                                                    v-model="Quote.shippingData.destinationItem.destination"
                                                    :suggestions="dropdownlistSource.destinationPort"
                                                    @complete="searchPort($event, 'Destination')" field="eName" />
                                                <label :class="{ inValidate: Validate.destination }"
                                                    for="destination">Destination<span
                                                        style="color: #f68b39">*</span></label>
                                            </span>
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <div class="field-checkbox">
                                                <Checkbox @change="checkRequired" inputId="destinationCkb" class="p-mr-2"
                                                    v-model="Quote.shippingData.destinationItem.destinationDeliveryService"
                                                    :binary="true" />
                                                <label for="destinationCkb">Destination Delivery Service</label>
                                            </div>
                                        </div>
                                        <div class="p-field p-col-12 p-md-6">
                                            <div v-if="Quote.mode != 'AIR'" class="field-checkbox">
                                                <Checkbox inputId="devanningServiceCkb" class="p-mr-2"
                                                    v-model="Quote.shippingData.destinationItem.DevanningService"
                                                    :binary="true" />
                                                <label for="devanningServiceCkb">Devanning Service</label>
                                            </div>
                                        </div>
                                        <div v-if="Quote.shippingData.destinationItem.destinationDeliveryService"
                                            class="p-field p-col-12 p-md-12">
                                            <div class="p-fluid p-formgrid p-grid">
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label :class="{ inValidate: Validate.destinationCountry }"
                                                        for="countryName">Country / Area<span
                                                            style="color: #f68b39">*</span></label>
                                                    <AutoComplete @change="checkRequired" id="countryName"
                                                        @blur="checkRequired"
                                                        v-model="Quote.shippingData.destinationItem.country"
                                                        optionLabel = "eName"
                                                        :dropdown="true"
                                                        :suggestions="dropdownlistSource.destination.country"
                                                        @item-select="getChildSource($event, 'ShippingDestinationCountry')"
                                                        @complete="SearchAutoComplete($event, 'ShippingDestinationCountry')"
                                                        field="eName" />
                                                </div>
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label :class="{ inValidate: Validate.destinationZipCode }"
                                                        for="zipPostalCode">Zip / Postal Code<span
                                                            style="color: #f68b39">*</span></label>
                                                    <InputText id="zipPostalCode" @change="checkRequired" type="text"
                                                        v-model="Quote.shippingData.destinationItem.zipCode" />
                                                </div>
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label :class="{ inValidate: Validate.destinationCity }"
                                                        for="cityName">City<span style="color: #f68b39">*</span></label>
                                                    <AutoComplete @change="checkRequired" id="cityName"
                                                        @blur="checkRequired"
                                                        v-model="Quote.shippingData.destinationItem.city" :dropdown="true"
                                                        :suggestions="dropdownlistSource.destination.city"
                                                        @item-select="getChildSource($event, 'ShippingDestinationCity')"
                                                        @complete="SearchAutoComplete($event, 'ShippingDestinationCity')"
                                                        field="eName" />
                                                </div>
                                                <div class="p-field p-col-12 p-md-6">
                                                    <label for="stateProvince">State / Province</label>
                                                    <InputText id="stateProvince" type="text"
                                                        v-model="Quote.shippingData.destinationItem.state.eName" />
                                                </div>
                                                <div class="p-field p-col-12">
                                                    <label :class="{ inValidate: Validate.destinationAddress }"
                                                        for="address">Address<span style="color: #f68b39">*</span></label>
                                                    <InputText id="address" @change="checkRequired" type="text"
                                                        v-model="Quote.shippingData.destinationItem.address"
                                                        :maxlength="500" />
                                                </div>
                                                <div class="p-field p-col-12">
                                                    <span>Special Instruction (Destination)</span>
                                                </div>
                                                <div class="p-field p-col-12 p-md-12">
                                                    <div class="field-checkbox">
                                                        <Checkbox inputId="nonRegularCkb" class="p-mr-2"
                                                            v-model="Quote.shippingData.destinationItem.nonRegularDeliveryService"
                                                            :binary="true" />
                                                        <label for="nonRegularCkb">Non-regular delivery service (By
                                                            appointment Only)</label>
                                                    </div>
                                                </div>
                                                <div class="p-field p-col-12 p-md-12">
                                                    <div class="field-checkbox">
                                                        <Checkbox inputId="noLoadingCkb" class="p-mr-2"
                                                            v-model="Quote.shippingData.destinationItem.noLoadingDockHandCarry"
                                                            :binary="true" />
                                                        <label for="noLoadingCkb">No loading dock / hand carry-in
                                                            delivery</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12">
                        <div class="SubjectLable">Do you need any value added services?</div>
                    </div>
                    <div class="p-col-12">
                        <div class="card">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-12 p-md-12">
                                    <div class="field-checkbox p-mb-2">
                                        <Checkbox inputId="insuranceCkb" v-model="Quote.servicePackage.insurance"
                                            :binary="true" class="p-mr-2" />
                                        <label for="insuranceCkb">Insurance</label>
                                    </div>
                                    <div v-if="Quote.servicePackage.insurance" class="field p-ml-6 p-md-4">
                                        <label for="insuranceCurrencyInput">Cargo Value in Commericial Invoice</label>
                                        <InputNumber inputId="insuranceCurrencyInput" :min="0"
                                            v-model="Quote.servicePackage.cargoValueINCommerciaInvoice" showButtons
                                            mode="currency" currency="USD" />
                                    </div>
                                </div>
                                <div class="p-field p-col-12 p-md-12">
                                    <div class="field-checkbox p-mb-2">
                                        <Checkbox inputId="CustomsBroberageCkb"
                                            v-model="Quote.servicePackage.customsBrokerage.selected" :binary="true"
                                            class="p-mr-2" />
                                        <label for="CustomsBroberageCkb">Customs Brokerage</label>
                                    </div>
                                    <div v-if="Quote.servicePackage.customsBrokerage.selected" class="field p-ml-6">
                                        <Checkbox inputId="CustomsBroberageOriginCkb"
                                            v-model="Quote.servicePackage.customsBrokerage.origin" :binary="true"
                                            class="p-mr-2" />
                                        <label for="CustomsBroberageOriginCkb">Origin</label>
                                        <Checkbox inputId="CustomsBroberageDestinationCkb"
                                            v-model="Quote.servicePackage.customsBrokerage.destination" :binary="true"
                                            class="p-mr-2 p-ml-2" />
                                        <label for="CustomsBroberageDestinationCkb">Destination</label>
                                        <p class="p-mt-2">Please upload customs document. The size must be less than 5 MB.
                                        </p>

                                        <FileUpload name="customsBrokerage[]" :auto="true" :customUpload="true"
                                            @uploader="CBrokerageFileUpload" :multiple="true"
                                            accept=".docx,.pptx,.ppt,.pdf,.dot,.doc,.tif,.pjp,.apng,.xbm,.jxl,.svgz,.jpg,.jpeg,.ico,.tiff,.gif,.svg,.jfif,.webp,.png,.bmp,.pjpeg,.avif,.xlsx,.xls,.csv"
                                            :maxFileSize="5000000" :showUploadButton="false" :showCancelButton="true"
                                            @clear="CargoFileRemove('CBrokerage')">
                                            <template #empty>
                                                <p>Drag and drop files to here to upload.</p>
                                            </template>
                                        </FileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-col-12 p-md-12">
                                    <div class="field-checkbox">
                                        <Checkbox @change="checkRequired" inputId="DNFCargoCkb"
                                            v-model="Quote.servicePackage.dangerousNFlammableCargo.selected" :binary="true"
                                            class="p-mr-2" />
                                        <label for="DNFCargoCkb">Dangerous & Flammable Cargo? (Declared by Shipper)</label>
                                    </div>
                                    <div v-if="Quote.servicePackage.dangerousNFlammableCargo.selected" class="field p-ml-6">
                                        <p :class="{ inValidate: Validate.dangerousNFlammableCargo }">Please upload MSDS
                                            document<span style="color: #f68b39">*</span></p>
                                        <FileUpload name="DNFCargo[]" :auto="true" :customUpload="true"
                                            @uploader="DNFCargoFileUpload" :multiple="true"
                                            accept=".docx,.pptx,.ppt,.pdf,.dot,.doc,.tif,.pjp,.apng,.xbm,.jxl,.svgz,.jpg,.jpeg,.ico,.tiff,.gif,.svg,.jfif,.webp,.png,.bmp,.pjpeg,.avif,.xlsx,.xls,.csv"
                                            :maxFileSize="5000000" :showUploadButton="false" :showCancelButton="true"
                                            @clear="CargoFileRemove('DNFCargo')">
                                            <template #empty>
                                                <p>Drag and drop files to here to upload.</p>
                                            </template>
                                        </FileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-col-12 p-md-12">
                                    <Textarea
                                        placeholder="Please supplement any other comments or requirements (i.e., temperature control, routing preference, special service, HS/HTS code)"
                                        v-model="Quote.servicePackage.Description" :autoResize="true" rows="5" cols="30"
                                        :maxlength="2000" aria-describedby="supplementComments" />
                                    <small id="supplementComments" class="p-text-right" style="color: var(--blue-500)">maximum 2000
                                        characters</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12" v-if="!isMyDimerco">
                        <div class="SubjectLable">Who should we contact about this quote?</div>
                    </div>
                    <div class="p-col-12" v-if="!isMyDimerco">
                        <div class="card">
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col-6">
                                    <h5>Are you currently a Dimerco Customer?</h5>
                                    <div class="p-field-radiobutton">
                                        <RadioButton id="isDimercoCustomer" name="option" value="1"
                                            v-model="Quote.contactInformation.isDimercoCustomer" />
                                        <label for="isDimercoCustomer">Yes</label>
                                        <RadioButton id="isNotDimercoCustomer" class="p-ml-4" name="option" value="0"
                                            v-model="Quote.contactInformation.isDimercoCustomer" />
                                        <label for="isNotDimercoCustomer">No</label>
                                    </div>
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label v-if="Quote.contactInformation.isDimercoCustomer === '1'" :class="{ inValidate: Validate.salseEmail }" for="salseEmail">Your
                                        Sales Email Address</label>
                                    <InputText v-if="Quote.contactInformation.isDimercoCustomer === '1'" id="salseEmail"
                                        type="text" v-model="Quote.contactInformation.salseEmail"
                                               @change="checkRequired"/>
                                    <small v-if="Quote.contactInformation.isDimercoCustomer === '1' && Validate.salseEmail" class="p-error p-text-right" >Please enter a valid email address</small>
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label :class="{ inValidate: Validate.firstName }" for="firstName">First Name<span
                                            style="color: #f68b39">*</span></label>
                                    <InputText id="firstName" type="text" @change="checkRequired"
                                        v-model="Quote.contactInformation.firstName" />
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label :class="{ inValidate: Validate.lastName }" for="lastName">Last Name<span
                                            style="color: #f68b39">*</span></label>
                                    <InputText id="lastName" type="text" @change="checkRequired"
                                        v-model="Quote.contactInformation.lastName" />
                                </div>
                                <div class="p-field p-col-12">
                                    <label :class="{ inValidate: Validate.companyName }" for="companyName">Company Name<span
                                            style="color: #f68b39">*</span></label>
                                    <InputText id="companyName" type="text" @change="checkRequired"
                                        v-model="Quote.contactInformation.companyName" />
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label :class="{ inValidate: Validate.businessMail }" for="businessMail">Business
                                        E-mail<span style="color: #f68b39">*</span></label>
                                    <InputText id="businessMail" type="email" @change="checkRequired"
                                        v-model="Quote.contactInformation.businessemail" />
                                    <small v-if="Validate.businessMail" class="p-error p-text-right" >Please enter a valid email address</small>
                                </div>
                                <div class="p-field p-col-12 p-md-2">
                                    <label for="countryCode">Phone</label>
                                    <AutoComplete @change="checkRequired" id="countryCode" @blur="checkRequired"
                                        v-model="Quote.contactInformation.phoneCode" :dropdown="true"
                                        :suggestions="dropdownlistSource.PhonePrefix"
                                        @complete="SearchAutoComplete($event, 'Phone')" field="eName" />
                                </div>
                                <div class="p-field p-col-12 p-md-4">
                                    <label for="phoneNo">&nbsp;</label>
                                    <InputText id="phoneNo" type="text" v-model="Quote.contactInformation.phoneNo" />
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label :class="{ inValidate: Validate.contactCountry }" for="contactCountry">Country /
                                        Area<span style="color: #f68b39">*</span></label>
                                    <AutoComplete @change="checkRequired" id="contactCountry" @blur="checkRequired"
                                        v-model="Quote.contactInformation.country" :dropdown="true"
                                        :suggestions="dropdownlistSource.contactCountry"
                                        @item-select="getChildSource($event, 'contactCountry')"
                                        @complete="SearchAutoComplete($event, 'contactCountry')" field="eName" />
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label for="stateProvince">State / Province</label>
                                    <InputText id="stateProvince" type="text"
                                        v-model="Quote.contactInformation.state.eName" />
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label :class="{ inValidate: Validate.contactCity }" for="cityName">City<span
                                            style="color: #f68b39">*</span></label>
                                    <AutoComplete @change="checkRequired" id="cityName" @blur="checkRequired"
                                        v-model="Quote.contactInformation.city" :dropdown="true"
                                        :suggestions="dropdownlistSource.contactCity"
                                        @item-select="getChildSource($event, 'contactCity')"
                                        @complete="SearchAutoComplete($event, 'contactCity')" field="eName" />
                                </div>
                                <div class="p-field p-col-12 p-md-6">
                                    <label :class="{ inValidate: Validate.contactZipCode }" for="zipPostalCode">Zip / Postal
                                        Code<span style="color: #f68b39">*</span></label>
                                    <InputText id="zipPostalCode" @change="checkRequired" type="text"
                                        v-model="Quote.contactInformation.zipCode" />
                                </div>
                                <div class="p-field p-col-12 p-md-12">
                                    <label :class="{ inValidate: Validate.contactAddress }" for="address">Address<span
                                            style="color: #f68b39">*</span></label>
                                    <InputText id="address" @change="checkRequired" type="text"
                                        v-model="Quote.contactInformation.address" :maxlength="500" />
                                </div>
                                <div class="p-field p-col-12 p-md-12">
                                    <label :class="{ inValidate: Validate.whereKnowDimercoFrom }"
                                        for="whereKnowDimercoFrom">How Did You Hear About Us?<span
                                            style="color: #f68b39">*</span></label>
                                    <InputText id="whereKnowDimercoFrom" @change="checkRequired" type="text"
                                        v-model="Quote.contactInformation.hearAboutUS" />
                                </div>
                                <div class="p-field p-col-12 p-md-12">
                                    <Checkbox inputId="subscription" v-model="Quote.contactInformation.subscribe"
                                        :binary="true" class="p-mr-2" style="padding-bottom: 46px" />
                                    <label
                                        style="font-size: 1.1rem; width: 96%; line-height: 1.5rem; letter-spacing: 0; font-weight: bold"
                                        for="subscription">
                                        I would like to receive Dimerco newsletters, blog posts and other promotional
                                        messages. You can unsubscribe at any time via our
                                        <a class="textDecoration" @click.prevent="displayPrivacyPolicy = true"
                                            href="#">Privacy Policy</a>.
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer id="footer" style="padding: 14px; line-height: 21px; font-size: 14px; position: sticky">
                <ProgressBar v-if="blocked" mode="indeterminate" style="height: 6px;margin-bottom:2px;"></ProgressBar>
                <div class="p-formgroup-inline" style="display: inline-flex">
                    <div class="p-field" style="padding: 5px 0px; margin: 0px">
                        <span style="font-weight: bold; font-size: small; margin-right: 10px">Total</span>
                        <span style="font-weight: bold; font-size: large">{{ numberToCurrencyNo(Quote.totalUnit) }}</span>
                        <span style="font-weight: bold; font-size: small; margin-left: 5px; margin-right: 10px">{{
                            Quote.mode === 'FCL' ? 'Containers' : 'UNIT' }}</span>
                        <span v-if="Quote.mode === 'AIR' || Quote.mode === 'LCL'"
                            style="font-weight: bold; font-size: large">{{ numberToCurrencyNo(Quote.totalCBM) }}</span>
                        <span v-if="Quote.mode === 'AIR' || Quote.mode === 'LCL'"
                            style="font-weight: bold; font-size: small; margin-left: 5px; margin-right: 10px">{{
                                displayText.totalCBMText }}</span>
                        <span v-if="Quote.mode === 'AIR' || Quote.mode === 'LCL'"
                            style="font-weight: bold; font-size: small; margin-right: 10px">G/W</span>
                        <span v-if="Quote.mode === 'AIR' || Quote.mode === 'LCL'"
                            style="font-weight: bold; font-size: large">{{ numberToCurrencyNo(Quote.totalGW) }}</span>
                        <span v-if="Quote.mode === 'AIR' || Quote.mode === 'LCL'"
                            style="font-weight: bold; font-size: small; margin-left: 5px; margin-right: 10px">{{
                                displayText.totalVolumnText }}</span>
                        <span v-if="Quote.mode === 'AIR'"
                            style="font-weight: bold; font-size: small; margin-right: 10px">V/W</span>
                        <span v-if="Quote.mode === 'AIR'" style="font-weight: bold; font-size: large">{{
                            numberToCurrencyNo(Quote.totalVW) }}</span>
                        <span v-if="Quote.mode === 'AIR'"
                            style="font-weight: bold; font-size: small; margin-left: 5px; margin-right: 10px">{{
                                displayText.totalVolumnText }}</span>
                        <span v-if="Quote.mode === 'AIR'"
                            style="font-weight: bold; font-size: small; margin-right: 10px">C/W</span>
                        <span v-if="Quote.mode === 'AIR'" style="font-weight: bold; font-size: large">{{
                            numberToCurrencyNo(Quote.totalCW) }}</span>
                        <span v-if="Quote.mode === 'AIR'"
                            style="font-weight: bold; font-size: small; margin-left: 5px; margin-right: 10px">{{
                                displayText.totalVolumnText }}</span>
                    </div>
                    <Button type="submit" :disabled="!showSubmit" label="Submit" @click="handleSubmit()"
                        style="margin-left: 5px" />
                </div>
            </footer>
        </div>
    </form>
    <Dialog header="Privacy Policy" v-model:visible="displayPrivacyPolicy" :style="{ width: '50vw' }" :modal="true">
        <h5>Dimerco Express Corporation Privacy Policy</h5>
        <p>Last modified: January 16, 2019</p>
        <p>
            Under the Terms, "Dimerco" means Dimerco Express Corporation, with offices at 11F., No. 160, Sec. 6, Minquan E.
            Rd., Neihu Dist., Taipei City 114 , Taiwan (R.O.C.). We may refer to "Dimerco " as "we", "our", or "us" in the
            Terms. We are
            committed to protecting and respecting your privacy. This Privacy Policy is designed to tell you about our
            practices regarding the collection, use and disclosure of information that you may provide via this website and
            our marketing
            activities. This Privacy Notice sets out the basis on which any personal data we collect from you, or that you
            provide to us, will be processed by us. Please read the following carefully to understand our views and
            practices regarding
            your personal data and how we will treat it.
        </p>
        <p style="color: #025984; font-size: 1.5rem">What information do we collect about you?</p>
        <p>We collect information about you when you:</p>
        <ul>
            <li>Contact us to provide feedback.</li>
            <li>Participate in our customer surveys.</li>
        </ul>
        <p>
            We may also collect information about you from other sources, such as public databases, public websites and
            social media platforms (e.g. Linkedin) to identify individuals and the companies they work for, who potentially
            might be
            interested in our products or services.
        </p>
        <p>Website usage information is also collected using cookies.</p>
        <p>The information we collect may include:</p>
        <ul>
            <li>Your name, job function and the company for which you work.</li>
            <li>Business telephone number and email address.</li>
        </ul>
        <p style="color: #025984; font-size: 1.5rem">Why will we collect information about you?</p>
        <p>
            We collect personal information to allow us to provide you and your organisation with information on our
            products and services that we believe will be of benefit. Under the new data protection law which is coming into
            effect on the 25th
            May 2018, this is referred to as 'Legitimate Interests'.
        </p>
        <p>Legitimate Interests means that we can process your personal information if we have a genuine and legitimate
            reason and we are not harming any of your rights and interests.</p>
        <p style="color: #025984; font-size: 1.5rem">How will we use the information about you?</p>
        <p>We will only use this information to:</p>
        <ul>
            <li>Contact you via telephone or email to notify you about our products and services or other information which
                we think may be of interest to you.</li>
            <li>Inform you of any events such as webinars or seminars that we are running.</li>
            <li>Contact you for market research purposes.</li>
            <li>Customise your website experience based on our cookie policy.</li>
        </ul>
        <p>You will always have the option to unsubscribe from our marketing activities and have your data removed.</p>
        <p style="color: #025984; font-size: 1.5rem">Controlling your personal information</p>
        <p>You can choose to restrict the collection or use of your personal information in the following ways:</p>
        <ul>
            <li>Whenever you are asked to fill in a form on the website, look for the box that you can click to indicate
                what are your preferences.</li>
            <li>If we are processing your personal information for marketing purposes, you may change your mind at any time
                by emailing us at the contact details provided below.</li>
        </ul>
        <p>We may share your personal information within the Dimerco Express Corporation and its subsidiaries. We ensure
            that it takes place in accordance with this Privacy Notice and is protected by appropriate safeguards.</p>
        <p>We only process your personal information using secure and trusted commercially available CRM and marketing
            automation software and we will not sell, distribute or lease your personal information to any third parties.
        </p>
        <p>Where permitted by law, you have the right to obtain a copy of personal information that we hold about you.
            Before responding to your request, we may ask you to:</p>
        <ul>
            <li>Verify your identity.</li>
            <li>Provide further details so we can better respond to your request.</li>
        </ul>
        <p>We will endeavour to respond as quickly as possible and, in any event, within any timeframe required by law. If
            you want to exercise this right, please contact us using the contact details provided below.</p>
        <p>If you believe that any information we are holding on you is incorrect or incomplete, please contact us as soon
            as possible and we will promptly correct any information found to be incorrect.</p>
        <p>You also have the right to make a complaint to the relevant data protection supervisory authority or to seek a
            remedy through the courts if you believe that your rights have been breached.</p>
        <p style="color: #025984; font-size: 1.5rem">Change to our Privacy Notice</p>
        <p>Dimerco may change this policy from time to time by updating this page. You should check this page from time to
            time to ensure that you are happy with any changes. This Privacy Notice was last updated on 16 Jan 2019 .</p>
        <p style="color: #025984; font-size: 1.5rem">How to contact us</p>
        <p>By email: <a href="mailto:marketing@dimerco.com">marketing@dimerco.com</a></p>
        <p style="color: #025984; font-size: 1.5rem">Security</p>
        <p>
            We are committed to ensuring that your information is secure. To prevent unauthorised access or disclosure, we
            have put in place suitable physical, electronic and managerial procedures to safeguard and secure the
            information we collect.
        </p>
        <p style="color: #025984; font-size: 1.5rem">Cookies</p>
        <p>
            A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the
            file is added and the cookie helps analyse web traffic or lets you know when you visit a particular site.
            Cookies allow web
            applications to respond to you as an individual. The web application can tailor its operations to your needs,
            likes and dislikes by gathering and remembering information about your preferences.
        </p>
        <p>You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually
            modify your browser setting to decline cookies if you prefer.</p>
        <p style="color: #025984; font-size: 1.5rem">Links to other websites</p>
        <p>Our website may contain links to other websites of interest. However, once you have used these links to leave our
            site, you should note that we do not have any control over that other website.</p>
        <p>
            Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst
            visiting such sites and such sites are not governed by this Privacy Notice. You should exercise caution and look
            at the privacy
            statement applicable to the website in question.
        </p>
        <template #footer>
            <Button label="Confirm" icon="pi pi-check" @click="closePrivacyPolicy" autofocus />
        </template>
    </Dialog>
    <Dialog header="Header" v-model:visible="displayModal" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '50vw' }" :modal="true">
        <p class="m-0">{{submitMessage}}</p>
        <template #footer>
            <Button label="Close" icon="pi pi-check" @click="closeModal" autofocus />
        </template>
    </Dialog>
    <BlockUI :blocked="blocked" fullScreen />
</template>

<script>
import QuoteService from '../service/QuoteService';
import moment from "moment";
import router from "../router";
import { validateEmail } from "../utils/validateEmail.js";
export default {
    data() {
        return {
            validateEmail,
            CargoDetailShipmentType: 'AIR',
            isDimercoCustomer: null,
            autoCompleteSource: {
                shipping: {
                    origin: {
                        country: [],
                        state: [],
                        city: [],
                    },
                    destination: {
                        country: [],
                        state: [],
                        city: [],
                    },
                },
                countryPhoneCodeSourceData: [],
                contactCountry: [],
                contactCity: [],
                countryCodeSourceData: null,
                shippingCityCodeSourceData: null,
                shippingStateCodeSourceData: null,
            },
            dropdownlistSource: {
                origin: {
                    country: [],
                    state: [],
                    city: [],
                },
                destination: {
                    country: [],
                    state: [],
                    city: [],
                },
                originPort: [],
                destinationPort: [],
                PhonePrefix: [],
                contactCountry: [],
                contactCity: [],
                contactState: [],
                weightUnit: [],
                volumeUnit: [],
                quantityUnit: [],
                lengthUnit: [],
                knowMoreOptions: [
                    { eName: 'Air Freight', eValue: 'AMS' },
                    { eName: 'Ocrean Freight', eValue: 'OMS' },
                    { eName: 'Truck', eValue: 'TMS' },
                    { eName: 'WareHouse', eValue: 'WMS' },
                ],
            },
            autoCompleteSelectedItem: {
                selectedCountryPhone: '',
                selectedCountry: '',
                selectedCity: '',
            },
            countryCodeID: null,
            isAirSelected: true,
            isFCLSelected: false,
            isLCLSelected: false,
            minDate: null,
            cargoReadyDateValue: null,
            cargoDetailItemIndex: 0,
            Quote: {
                guid: null,
                cargoReadyDate: null,
                mode: 'AIR',
                cargoDataType: '0',
                CargoDetailList: [
                    {
                        detailItemID: 0,
                        cargoDescript: null,
                        hsCode: '',
                        QTY: null,
                        Type: { eName: 'PALLET', eValue: '75' },
                        L: null,
                        W: null,
                        H: null,
                        unit: { eName: 'CM', eValue: 'CM' },
                        weight: null,
                        weightPreUnit: { eName: 'KG', eValue: 'KG' },
                        subTotalCBM: 0,
                        subTotalWeight: 0,
                        cargoDescriptValidate: false,
                        QTYValidate: false,
                        TypeValidate: false,
                        LValidate: false,
                        HValidate: false,
                        WValidate: false,
                        weightValidate: false,
                    },
                ],
                TotalItem: {
                    QTY: null,
                    totalWeight: null,
                    totalWeightUnit: { eName: 'KG', eValue: 'KG' },
                    totalVolume: null,
                    totalVolumUnit: { eName: 'CBM', eValue: 'CBM' },
                    caegoDescription: null,
                    hsCode: '',
                },
                FCLItem: {
                    standardTwenty: 0,
                    standardForty: 0,
                    standardFortyHC: 0,
                    standardFortyFiveHC: 0,
                    caegoDescription: '',
                    hsCode: '',
                },
                shippingData: {
                    originItem: {
                        origin: { eName: '', eValue: '' },
                        originPickupService: false,
                        stuffingService: false,
                        country: { eName: '', eValue: '' },
                        zipCode: '',
                        city: { eName: '', eValue: '' },
                        state: { eName: '', eValue: '' },
                        address: '',
                        nonRegularDeliveryService: false,
                        noLoadingDockHandCarry: false,
                    },
                    destinationItem: {
                        destination: { eName: '', eValue: '' },
                        destinationDeliveryService: false,
                        DevanningService: false,
                        country: { eName: '', eValue: '' },
                        zipCode: '',
                        city: { eName: '', eValue: '' },
                        state: { eName: '', eValue: '' },
                        address: '',
                        nonRegularDeliveryService: false,
                        noLoadingDockHandCarry: false,
                    },
                },
                servicePackage: {
                    insurance: false,
                    cargoValueINCommerciaInvoice: 0,
                    customsBrokerage: {
                        selected: false,
                        origin: false,
                        destination: false,
                        Files_Brokerage: {
                            ModeCode: '',
                            KeyValue: '',
                            Files: [],
                        },
                    },
                    dangerousNFlammableCargo: {
                        selected: false,
                        Files_Dangerous: {
                            ModeCode: '',
                            KeyValue: '',
                            Files: null,
                        },
                    },
                    Description: '',
                },
                contactInformation: {
                    isDimercoCustomer: '0',
                    firstName: '',
                    lastName: '',
                    companyName: '',
                    businessemail: '',
                    phoneCode: { eName: '', eValue: '' },
                    phoneNo: '',
                    country: { eName: '', eValue: '' },
                    state: { eName: '', eValue: '' },
                    city: { eName: '', eValue: '' },
                    zipCode: '',
                    address: '',
                    salseEmail: '',
                    subscribe: true,
                    hearAboutUS: '',
                    knowMore: { eName: '', eValue: '' },
                },
                totalUnit: 0,
                totalCBM: 0,
                totalGW: 0,
                totalVW: 0,
                totalCW: 0,
                totalContainers: 0,
                Files_Cargo: {
                    ModeCode: null,
                    KeyValue: null,
                    Files: [],
                },
            },
            displayPrivacyPolicy: false,
            showSubmit: false,
            displayText: {
                TotalUnitText: 'UNIT',
                totalCBMText: 'CBM',
                totalVolumnText: 'KG',
                cargoDetailSubTotalCubicUOM: "CBM",
                cargoDetailSubTotalVolumeUOM: "KG",
            },
            uploadedFiles: [],
            files: [],
            totalSize: 0,
            totalSizePercent: 0,
            displayModal: false,
            Validate: {
                isCargoReadyDateInValidate: false,
                iscdCargoDescriptionInValidate: false,
                iscdQTYInValidate: false,
                iscdCargoDescriptionTypeInValidate: false,
                iscdCargoDescriptionLInValidate: false,
                iscdCargoDescriptionHInValidate: false,
                iscdCargoDescriptionWInValidate: false,
                iscdCargoDescriptionWrightInValidate: false,
                isTotalItemQTYInValidate: false,
                isTotalItemTotalWeightInValidate: false,
                isTotalItemTotalVolumeInValidate: false,
                isTotalItemCargoDescriptionInValidate: false,
                isFLCcargoDescriptionInValidate: false,
                origin: false,
                OriginCountry: false,
                OriginZipCode: false,
                OriginCity: false,
                OriginAddress: false,
                destination: false,
                destinationCountry: false,
                destinationZipCode: false,
                destinationCity: false,
                destinationAddress: false,
                firstName: false,
                lastName: false,
                companyName: false,
                businessMail: false,
                contactCountry: false,
                contactCity: false,
                contactZipCode: false,
                contactAddress: false,
                whereKnowDimercoFrom: false,
                dangerousNFlammableCargo: false,
            },
            blocked: false,
            isMyDimerco:false,
            contactID: null,
            submitMessage: "Submit successful. We have received your request for Get a Quote, thank you."
        };
    },
    created() {
        this.quoteService = new QuoteService();
    },
    mounted() {
        router.isReady().then(()=>{
            if(this.$route.query.isMyDimerco == '1' && this.$route.query.contact){
            this.submitMessage = "Submission successful. Our team will reach out to you shortly. Thank you "
            this.isMyDimerco = true;
            this.Quote.cargoReadyDate = this.$route.query.cargoReadyDate;
            if(this.$route.query.mode){
                document.getElementById(this.$route.query.mode.toUpperCase()).click();
            }
            if(this.$route.query.origin){
                this.Quote.shippingData.originItem.origin = { eName: this.$route.query.originName, eValue: this.$route.query.origin };
            }
            if(this.$route.query.dSTN){
                this.Quote.shippingData.destinationItem.destination = { eName: this.$route.query.dSTNName, eValue: this.$route.query.dSTN };
            }
            this.contactID = this.$route.query.contact;
        } 

        this.minDate = new Date();
        var dropdownPara = { SourceType: 2, ParentID: 0, Prefix: null };
        this.getDropDownSource(dropdownPara, 'ShippingOriginCountry');
        this.getDropDownSource(dropdownPara, 'ShippingDestinationCountry');
        this.getDropDownSource(dropdownPara, 'contactCountry');

        dropdownPara = { SourceType: 6, ParentID: 0, Prefix: null };
        this.getDropDownSource(dropdownPara, 'ddlSource');
        dropdownPara = { SourceType: 7, ParentID: 0, Prefix: null };
        this.getDropDownSource(dropdownPara, 'ddlSource');
        dropdownPara = { SourceType: 8, ParentID: 2, Prefix: null };
        this.getDropDownSource(dropdownPara, 'ddlSource');
        dropdownPara = { SourceType: 9, ParentID: 0, Prefix: null };
        this.getDropDownSource(dropdownPara, 'ddlSource');

        dropdownPara = { SourceType: 1, ParentID: 0, Prefix: null };
        this.getDropDownSource(dropdownPara, 'PhonePrefix');

        let hubspotscript = document.createElement('script')
        hubspotscript.setAttribute('src', '//js.hs-scripts.com/8718167.js')
        hubspotscript.setAttribute('id', 'hs-script-loader')
        hubspotscript.setAttribute('async', '')
        hubspotscript.setAttribute('defer', '')
        document.body.appendChild(hubspotscript);
        this.hubspothsq();
        }).catch(error=>{
            console.log(error);
        });
        
    },
    computed: {},
    methods: {
        SearchAutoComplete(event, DropDownTarget) {                    
            setTimeout(() => {
                if (!event.query.trim().length) {
                    if (DropDownTarget === 'ShippingOriginCountry') {
                        this.dropdownlistSource.origin.country = this.autoCompleteSource.shipping.origin.country.slice(0, 500);
                    }
                    if (DropDownTarget === 'ShippingDestinationCountry') {
                        this.dropdownlistSource.destination.country = this.autoCompleteSource.shipping.destination.country.slice(0, 500);
                    }
                    if (DropDownTarget === 'ShippingOriginCity') {
                        this.dropdownlistSource.origin.city = this.autoCompleteSource.shipping.origin.city.slice(0, 500);
                    }
                    if (DropDownTarget === 'ShippingDestinationCity') {
                        this.dropdownlistSource.destination.city = this.autoCompleteSource.shipping.destination.city.slice(0, 500);
                    }
                    if (DropDownTarget === 'Phone') {
                        this.dropdownlistSource.PhonePrefix = this.autoCompleteSource.countryPhoneCodeSourceData.slice(0, 500);
                    }
                    if (DropDownTarget === 'contactCountry') {                        
                        this.dropdownlistSource.contactCountry = this.autoCompleteSource.contactCountry.slice(0, 500);
                    }
                    if (DropDownTarget === 'contactCity') {
                        this.dropdownlistSource.contactCity = this.autoCompleteSource.contactCity.slice(0, 500);
                    }
                } else {
                    if (DropDownTarget === 'ShippingOriginCountry') {
                        this.dropdownlistSource.origin.country = this.autoCompleteSource.shipping.origin.country.filter((options) => {
                            return options.eName.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
                        }).slice(0, 500);
                    }
                    if (DropDownTarget === 'ShippingDestinationCountry') {
                        this.dropdownlistSource.destination.country = this.autoCompleteSource.shipping.destination.country.filter((options) => {
                            return options.eName.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
                        }).slice(0, 500);
                    }

                    if (DropDownTarget === 'ShippingOriginCity') {
                        this.dropdownlistSource.origin.city = this.autoCompleteSource.shipping.origin.city.filter((options) => {
                            return options.eName.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
                        }).slice(0, 500);
                    }
                    if (DropDownTarget === 'ShippingDestinationCity') {
                        this.dropdownlistSource.destination.city = this.autoCompleteSource.shipping.destination.city.filter((options) => {
                            return options.eName.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
                        }).slice(0, 500);
                    }
                    if (DropDownTarget === 'Phone') {
                        this.dropdownlistSource.PhonePrefix = this.autoCompleteSource.countryPhoneCodeSourceData.filter((options) => {
                            return options.eName.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
                        }).slice(0, 500);
                    }
                    if (DropDownTarget === 'contactCountry') {
                        this.dropdownlistSource.contactCountry = this.autoCompleteSource.contactCountry.filter((options) => {
                            return options.eName.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
                        }).slice(0, 500);
                    }
                    if (DropDownTarget === 'contactCity') {

                        this.dropdownlistSource.contactCity = this.autoCompleteSource.contactCity.filter((options) => {
                            return options.eName.toLowerCase().indexOf(event.query.toLowerCase()) > -1;
                        }).slice(0, 500);
                    }
                }
            }, 250);
        },
        getChildSource(event, DropDownTarget) {
            if (typeof event.value != 'undefined' && event?.value != null) {
                var dropdownPara = null;
                switch (DropDownTarget) {
                    case 'ShippingOriginCountry':
                        dropdownPara = { SourceType: 4, ParentID: event.value.eValue, Prefix: null };
                        this.getDropDownSource(dropdownPara, 'ShippingOriginCity');
                        break;
                    case 'ShippingOriginCity':
                        dropdownPara = { SourceType: 3, ParentID: event.value.eValue, Prefix: null };
                        this.getDropDownSource(dropdownPara, 'ShippingOriginState');
                        break;
                    case 'ShippingDestinationCountry':
                        dropdownPara = { SourceType: 4, ParentID: event.value.eValue, Prefix: null };
                        this.getDropDownSource(dropdownPara, 'ShippingDestinationCity');
                        break;
                    case 'ShippingDestinationCity':
                        dropdownPara = { SourceType: 3, ParentID: event.value.eValue, Prefix: null };
                        this.getDropDownSource(dropdownPara, 'ShippingDestinationState');
                        break;
                    case 'contactCountry':
                        dropdownPara = { SourceType: 4, ParentID: event.value.eValue, Prefix: null };
                        this.getDropDownSource(dropdownPara, 'contactCity');
                        break;
                    case 'contactCity':
                        dropdownPara = { SourceType: 3, ParentID: event.value.eValue, Prefix: null };
                        this.getDropDownSource(dropdownPara, 'contactState');
                        break;
                }
            }
            this.checkRequired();
        },
        ShowItem(event) {
            this.countryCodeID = event.value.eValue;
            this.quoteService.getCountry(2, '', event.value.eValue).then((data) => {
                this.autoCompleteSource.cityCodeSourceData = data;
            });
        },
        selectedShipmentType(event, shipmentType) {
            let dropdownPara = {};
            switch (shipmentType) {
                case 'AIR':
                    this.isAirSelected = true;
                    this.isFCLSelected = false;
                    this.isLCLSelected = false;
                    dropdownPara = { SourceType: 8, ParentID: 2, Prefix: null };
                    this.getDropDownSource(dropdownPara, 'ddlSource');
                    break;
                case 'LCL':
                    this.isAirSelected = false;
                    this.isFCLSelected = false;
                    this.isLCLSelected = true;
                    dropdownPara = { SourceType: 8, ParentID: 6, Prefix: null };
                    this.getDropDownSource(dropdownPara, 'ddlSource');
                    break;
                case 'FCL':
                    this.isAirSelected = false;
                    this.isFCLSelected = true;
                    this.isLCLSelected = false;
                    break;
            }
            this.Quote.mode = shipmentType;
            this.recalculateAll();
            this.checkRequired();
        },
        AppendNewCargoDetail() {
            var newItem = {
                detailItemID: 0,
                cargoDescript: null,
                hsCode: '',
                QTY: null,
                Type: { eName: 'PALLET', eValue: '75' },
                L: null,
                W: null,
                H: null,
                unit: this.Quote.CargoDetailList[0].unit,
                weight: null,
                weightPreUnit: this.Quote.CargoDetailList[0].weightPreUnit,
                subTotalCBM: 0,
                subTotalWeight: 0,
            };
            this.cargoDetailItemIndex = this.cargoDetailItemIndex + 1;
            newItem.detailItemID = this.cargoDetailItemIndex;
            this.Quote.CargoDetailList.push(newItem);
        },
        handleSubmit() {
            let _CargoDetailList = [];
            this.Quote.CargoDetailList.forEach((item) => {
                let CargoDetailItem = {
                    Commodity: item.cargoDescript,
                    HSCode: item.hsCode,
                    PackageUOM: item.Type.eValue,
                    Quantity: item.QTY,
                    Length: item.L,
                    Width: item.W,
                    Height: item.H,
                    VolumeUOM: item.unit.eValue,
                    WT: item.weight,
                    WeightTUOM: item.weightPreUnit.eValue,
                    SubTotalCBM: item.subTotalCBM,
                    SubTotalKG: item.subTotalWeight,
                };
                _CargoDetailList.push(CargoDetailItem);
            });
            let resultParam = {
                GUIDKey: this.generateRandomString(6),
                CargoReadyDate: moment(this.Quote.cargoReadyDate).format('YYYY-MM-DD HH:mm:ss'),
                Mode: this.Quote.mode,
                Files_Cargo: this.Quote.Files_Cargo,
                CargoDetails: _CargoDetailList,
                CargoType: this.Quote.cargoDataType === "0" ? "detail" : "total",
                TotalInfo: {
                    Quantity: this.Quote.TotalItem.QTY,
                    Commodity: this.Quote.TotalItem.caegoDescription,
                    TotalVWT: this.Quote.TotalItem.totalVolume,
                    TotalWT: this.Quote.TotalItem.totalWeight,
                    VolumeUOM: this.Quote.TotalItem.totalVolumUnit.eValue,
                    WeightUOM: this.Quote.TotalItem.totalWeightUnit.eValue,
                    HSCode: this.Quote.TotalItem.hsCode,
                },
                FCLInfo: {
                    CNT20_Qty: this.Quote.FCLItem.standardTwenty,
                    CNT40_Qty: this.Quote.FCLItem.standardForty,
                    CNT40HC_Qty: this.Quote.FCLItem.standardFortyHC,
                    CNT45HC_Qty: this.Quote.FCLItem.standardFortyFiveHC,
                    HSCode: this.Quote.FCLItem.hsCode,
                    Commodity: this.Quote.FCLItem.caegoDescription,
                },
                Origin: {
                    Port: this.Quote.shippingData.originItem.origin.eValue,
                    NeedLocalService: this.Quote.shippingData.originItem.originPickupService,
                    NeedStuffingDevanningService: this.Quote.shippingData.originItem.stuffingService,
                    Country: this.Quote.shippingData.originItem.country.eValue,
                    ZIP: this.Quote.shippingData.originItem.zipCode,
                    City: this.Quote.shippingData.originItem.city.eValue,
                    State: this.Quote.shippingData.originItem.state.eValue,
                    Address: this.Quote.shippingData.originItem.address,
                    NoLoading: this.Quote.shippingData.originItem.nonRegularDeliveryService,
                    NonRegularDeliveryService: this.Quote.shippingData.originItem.noLoadingDockHandCarry,
                },
                Destination: {
                    Port: this.Quote.shippingData.destinationItem.destination.eValue,
                    NeedLocalService: this.Quote.shippingData.destinationItem.destinationDeliveryService,
                    NeedStuffingDevanningService: this.Quote.shippingData.destinationItem.DevanningService,
                    Country: this.Quote.shippingData.destinationItem.country.eValue,
                    ZIP: this.Quote.shippingData.destinationItem.zipCode,
                    City: this.Quote.shippingData.destinationItem.city.eValue,
                    State: this.Quote.shippingData.destinationItem.state.eValue,
                    Address: this.Quote.shippingData.destinationItem.address,
                    NoLoading: this.Quote.shippingData.destinationItem.nonRegularDeliveryService,
                    NonRegularDeliveryService: this.Quote.shippingData.destinationItem.noLoadingDockHandCarry,
                },
                AddService: {
                    NeedIsurance: this.Quote.servicePackage.insurance,
                    NeedBrokerage: this.Quote.servicePackage.customsBrokerage.selected,
                    BrokerageOrigin: this.Quote.servicePackage.customsBrokerage.origin,
                    BrokerageDestination: this.Quote.servicePackage.customsBrokerage.destination,
                    IsDangerousCargo: this.Quote.servicePackage.dangerousNFlammableCargo.selected,
                    CargoValue: this.Quote.servicePackage.cargoValueINCommerciaInvoice,
                    OtherComment: this.Quote.servicePackage.Description,
                    Files_Brokerage: this.Quote.servicePackage.customsBrokerage.Files_Brokerage,
                    Files_Dangerous: this.Quote.servicePackage.dangerousNFlammableCargo.Files_Dangerous,
                },
                Contact: {
                    IsDimercoCustomer: this.Quote.contactInformation.isDimercoCustomer === '1' ? true : false,
                    FirstName: this.Quote.contactInformation.firstName,
                    LastName: this.Quote.contactInformation.lastName,
                    CompanyName: this.Quote.contactInformation.companyName,
                    eMail: this.Quote.contactInformation.businessemail,
                    PhonePrefix: this.Quote.contactInformation.phoneCode.eValue,
                    Phone: this.Quote.contactInformation.phoneNo,
                    Country: this.Quote.contactInformation.country.eValue,
                    ZIP: this.Quote.contactInformation.zipCode,
                    City: this.Quote.contactInformation.city.eValue,
                    State: this.Quote.contactInformation.state.eValue,
                    Address: this.Quote.contactInformation.address,
                    HearAboutUS: this.Quote.contactInformation.hearAboutUS,
                    Subscribe: this.Quote.contactInformation.subscribe,
                    SalesEMail: this.Quote.contactInformation.salseEmail,
                },
                TotalUnit: this.Quote.totalUnit,
                TotalCBM: this.Quote.totalCBM,
                TotalGWT: this.Quote.totalGW,
                TotalVWT: this.Quote.totalVW,
                TotalCWT: this.Quote.totalCW,
                TotalContainers: this.totalContainers,
                IsMyDimerco:this.isMyDimerco,
                ContactID: this.contactID
            };


            this.blocked = true;
            this.showSubmit = !this.showSubmit;
            setTimeout(() => {
                this.quoteService.saveQuoteData(resultParam).then((data) => {
                    if (data.isSuccess) {
                        this.displayModal = true;
                        var _hsq = window._hsq = window._hsq || [];
                        _hsq.push(["identify", {
                            email: this.Quote.contactInformation.businessemail
                        }]);
                        _hsq.push(['setPath', '/#/getaquote']);
                        _hsq.push(['trackPageView']);

                    } else {
                        this.$toast.add({ severity: 'submit failed.', summary: 'Failed Message', detail: data.errorMessage, life: 3000 });
                        //Add By Wilson @ 20240506 only error need to show submit button
                        this.showSubmit = !this.showSubmit;
                    }
                }).catch(error => {
                    console.error(error);
                })
                    .finally(() => {
                        this.blocked = false;
                        // this.showSubmit = !this.showSubmit;
                    });
            }, 1000);

        },
        removeItem(itemID) {
            if (this.Quote.CargoDetailList.length > 1) {
                let i = this.Quote.CargoDetailList.map((item) => item.detailItemID).indexOf(itemID); // find index of your object
                this.Quote.CargoDetailList.splice(i, 1); // remove it from array
                this.recalculateAll();
            } else {
                return;
            }
        },
        getDropDownSource(dropdownPara, DropDownTarget) {
            this.quoteService.getDropDownList(dropdownPara).then((data) => {
                switch (DropDownTarget) {
                    case 'ShippingOriginCountry':
                        this.autoCompleteSource.shipping.origin.country = data;
                        break;
                    case 'ShippingDestinationCountry':
                        this.autoCompleteSource.shipping.destination.country = data;
                        break;
                    case 'ShippingOriginCity':
                        this.autoCompleteSource.shipping.origin.city = data;
                        break;
                    case 'ShippingDestinationCity':
                        this.autoCompleteSource.shipping.destination.city = data;
                        break;
                    case 'ShippingOriginState':
                        this.autoCompleteSource.shipping.origin.state = data;
                        if (data.length > 0) {
                            this.Quote.shippingData.originItem.state = data[0];
                        }
                        break;
                    case 'ShippingDestinationState':
                        this.autoCompleteSource.shipping.destination.state = data;
                        if (data.length > 0) {
                            this.Quote.shippingData.destinationItem.state = data[0];
                        }
                        break;
                    case 'PhonePrefix':
                        this.autoCompleteSource.countryPhoneCodeSourceData = data;
                        break;
                    case 'contactCountry':
                        this.autoCompleteSource.contactCountry = data;
                        break;
                    case 'contactCity':                        
                        this.autoCompleteSource.contactCity = data;
                        break;
                    case 'contactState':
                        this.autoCompleteSource.contactState = data;
                        if (data.length > 0) {
                            this.Quote.contactInformation.state = data[0];
                        }
                        break;
                    default:
                        switch (dropdownPara.SourceType) {
                            case 6:
                                this.dropdownlistSource.lengthUnit = data;
                                break;
                            case 7:
                                this.dropdownlistSource.weightUnit = data;
                                break;
                            case 8:
                                this.dropdownlistSource.quantityUnit = data;
                                break;
                            case 9:
                                this.dropdownlistSource.volumeUnit = data;
                                break;
                        }
                        break;
                }
            });
        },
        searchPort($evl, portType) {
            var dropdownPara = {};
            let Stype = 0;
            setTimeout(() => {
                switch (this.Quote.mode) {
                    case 'LCL':
                    case 'FCL':
                        Stype = 11;
                        break;
                    case 'AIR':
                    default:
                        Stype = 10;
                        break;
                }
                dropdownPara = { SourceType: Stype, ParentID: 0, Prefix: $evl.query.toLowerCase() };
                this.quoteService.getDropDownList(dropdownPara).then((data) => {
                    switch (portType) {
                        case 'Origin':
                            this.dropdownlistSource.originPort = data;
                            break;
                        case 'Destination':
                            this.dropdownlistSource.destinationPort = data;
                            break;
                    }
                });
            }, 250);
        },
        closePrivacyPolicy() {
            this.displayPrivacyPolicy = false;
        },
        recalculateCargoDetail(CargoDetailItem) {
            let _L = parseInt(CargoDetailItem.L);
            let _W = parseInt(CargoDetailItem.W);
            let _H = parseInt(CargoDetailItem.H);
            let _QTY = parseInt(CargoDetailItem.QTY);
            let _Weight = parseInt(CargoDetailItem.weight);
            let unitBase = CargoDetailItem.unit.eValue === 'CM' ? 0.01 : 2.54;
            let volumeBase = CargoDetailItem.unit.eValue === 'CM' ? 1 : 4.725;
            let factor = CargoDetailItem.unit.eValue === 'CM' ? 1 : 6000;
            let _subTotalCBM = (_L * unitBase * (_W * unitBase) * (_H * unitBase) * _QTY) / factor / volumeBase;
            let _subTotalWeight = _Weight * _QTY;
            CargoDetailItem.subTotalCBM = parseFloat(_subTotalCBM).toFixed(2);
            CargoDetailItem.subTotalWeight = _subTotalWeight;
            this.recalculateAll();
            this.checkRequired();
        },
        recalculateAll() {
            let _totalUnit = 0;
            let _totalCBM = 0;
            let _totalGW = 0;
            let _totalVW = 0;
            let _totalCW = 0;
            let _Mode = this.Quote.mode;
            let _cargoDataType = this.Quote.cargoDataType;

            if (_Mode === 'AIR' || _Mode === 'LCL') {
                switch (_cargoDataType) {
                    case '0':
                        this.Quote.CargoDetailList.forEach((item) => {
                            let _qty = Number.isNaN(parseInt(item.QTY)) ? 0 : parseInt(item.QTY);
                            let _L = Number.isNaN(parseFloat(item.L)) ? 0 : parseFloat(item.L);
                            let _W = Number.isNaN(parseFloat(item.W)) ? 0 : parseFloat(item.W);
                            let _H = Number.isNaN(parseFloat(item.H)) ? 0 : parseFloat(item.H);
                            let _weight = Number.isNaN(parseFloat(item.weight)) ? 0 : parseFloat(item.weight);
                            let _subTotalCubic = 0;
                            let _subTotalVolumn = 0;
                            switch (item.unit.eValue) {
                                case "CM":
                                    _subTotalCubic = ((_L / 100) * (_W / 100) * (_H / 100)) * _qty;
                                    _totalVW += (_L * _W * _H / 6000);
                                    break;
                                case "INCH":
                                    _subTotalCubic = (_L * _W * _H * 0.000578709) * _qty;
                                    _totalVW += _subTotalCubic * 4.71943;
                                    break;
                            }
                            _subTotalVolumn = _qty * _weight;
                            item.subTotalCBM = Number.isNaN(parseFloat(_subTotalCubic)) ? 0 : parseFloat(_subTotalCubic).toFixed(3);
                            _totalCBM += _subTotalCubic;
                            _totalUnit += _qty;
                            if (item.weightPreUnit.eValue === 'LB') {
                                _totalVW = _totalVW * 2.204620205867287;
                            }
                            _totalGW += _subTotalVolumn;
                            _totalCW = _totalGW > _totalVW ? _totalGW : _totalVW;
                        });
                        break;
                    case '1':
                        _totalUnit = Number.isInteger(this.Quote.TotalItem.QTY) ? parseInt(this.Quote.TotalItem.QTY) : 0;
                        _totalCBM = Number.isFinite(this.Quote.TotalItem.totalVolume) ? parseFloat(this.Quote.TotalItem.totalVolume) : 0;
                        _totalGW = Number.isFinite(this.Quote.TotalItem.totalWeight) ? parseFloat(this.Quote.TotalItem.totalWeight) : 0;
                        if (this.Quote.TotalItem.totalWeightUnit.eValue === 'LB') {
                            _totalVW = _totalCBM * 10.40464;
                        } else {
                            _totalVW = _totalCBM * 166.666666;
                        }
                        _totalCW = _totalGW > _totalVW ? _totalGW : _totalVW;
                        break;
                }
            } else {
                _totalUnit = parseInt(this.Quote.FCLItem.standardTwenty) + parseInt(this.Quote.FCLItem.standardForty) + parseInt(this.Quote.FCLItem.standardFortyHC) + parseInt(this.Quote.FCLItem.standardFortyFiveHC);
            }
            if (_totalVW > _totalCW) {
                _totalCW = Number.isNaN(_totalVW) ? 0 : _totalVW;
            }
            this.Quote.totalUnit = Number.isNaN(_totalUnit) ? 0 : _totalUnit;
            this.Quote.totalCBM = Number.isNaN(_totalCBM) ? 0 : _totalCBM.toFixed(3);
            this.Quote.totalGW = Number.isNaN(_totalGW) ? 0 : _totalGW.toFixed(3);
            this.Quote.totalVW = Number.isNaN(_totalVW) ? 0 : _totalVW.toFixed(3);
            this.Quote.totalCW = Number.isNaN(_totalCW) ? 0 : _totalCW.toFixed(3);
        },
        checkRequired() {

            let isInValidate = false;
            this.showSubmit = true;
            if (this.Quote.cargoReadyDate === null || this.Quote.cargoReadyDate === '') {
                this.Validate.isCargoReadyDateInValidate = true;
                isInValidate = true;
            } else {
                this.Validate.isCargoReadyDateInValidate = false;
            }
            if (this.Quote.mode === 'AIR' || this.Quote.mode === 'LCL') {
                switch (this.Quote.cargoDataType) {
                    case '0':
                        this.Quote.CargoDetailList.forEach((item) => {
                            if (item.QTY === null || item.QTY === '') {
                                item.QTYValidate = true;
                                isInValidate = true;
                            } else {
                                item.QTYValidate = false;
                            }
                            if (item.L === null || item.L === '') {
                                item.LValidate = true;
                                isInValidate = true;
                            } else {
                                item.LValidate = false;
                            }
                            if (item.W === null || item.W === '') {
                                item.WValidate = true;
                                isInValidate = true;
                            } else {
                                item.WValidate = false;
                            }
                            if (item.H === null || item.H === '') {
                                item.HValidate = true;
                                isInValidate = true;
                            } else {
                                item.HValidate = false;
                            }
                            if (item.Type === null || item.Type === '') {
                                item.TypeValidate = true;
                                isInValidate = true;
                            } else {
                                item.TypeValidate = false;
                            }
                            if (item.cargoDescript === null || item.cargoDescript === '') {
                                item.cargoDescriptValidate = true;
                                isInValidate = true;
                            } else {
                                item.cargoDescriptValidate = false;
                            }
                            if (item.weight === null || item.weight === '') {
                                item.weightValidate = true;
                                isInValidate = true;
                            } else {
                                item.weightValidate = false;
                            }
                        });
                        break;
                    case '1':
                        if (this.Quote.TotalItem.QTY === null || this.Quote.TotalItem.QTY === '') {
                            this.Validate.isTotalItemQTYInValidate = true;
                            isInValidate = true;
                        } else {
                            this.Validate.isTotalItemQTYInValidate = false;
                        }
                        if (this.Quote.TotalItem.totalWeight === null || this.Quote.TotalItem.totalWeight === '') {
                            this.Validate.isTotalItemTotalWeightInValidate = true;
                            isInValidate = true;
                        } else {
                            this.Validate.isTotalItemTotalWeightInValidate = false;
                        }
                        if (this.Quote.TotalItem.totalVolume === null || this.Quote.TotalItem.totalVolume === '') {
                            this.Validate.isTotalItemTotalVolumeInValidate = true;
                            isInValidate = true;
                        } else {
                            this.Validate.isTotalItemTotalVolumeInValidate = false;
                        }
                        if (this.Quote.TotalItem.caegoDescription === null || this.Quote.TotalItem.caegoDescription === '') {
                            this.Validate.isTotalItemCargoDescriptionInValidate = true;
                            isInValidate = true;
                        } else {
                            this.Validate.isTotalItemCargoDescriptionInValidate = false;
                        }
                        break;
                }
            }
            if (this.Quote.mode === 'FCL' && (this.Quote.FCLItem.caegoDescription === '' || this.Quote.FCLItem.caegoDescription === null)) {
                this.Validate.isFLCcargoDescriptionInValidate = true;
                isInValidate = true;
            }
            else {
                this.Validate.isFLCcargoDescriptionInValidate = false;
            }


            if (this.Quote.shippingData?.originItem?.origin != null && typeof this.Quote.shippingData?.originItem?.origin?.eValue === 'undefined') {
                const _originItem = { eName: this.Quote.shippingData?.originItem?.origin, eValue: this.Quote.shippingData?.originItem?.origin };
                this.Quote.shippingData.originItem.origin = _originItem;
                this.Validate.origin = false;
            } else if (this.Quote.shippingData?.originItem?.origin === null || this.Quote.shippingData?.originItem?.origin?.eValue === '') {
                this.Quote.shippingData.originItem.origin = null;
                this.Validate.origin = true;
                isInValidate = true;
            } else {
                this.Validate.origin = false;
            }

            if (this.Quote.shippingData?.destinationItem?.destination != null && typeof this.Quote.shippingData?.destinationItem?.destination?.eValue === 'undefined') {
                const _destinationItem = { eName: this.Quote.shippingData?.destinationItem?.destination, eValue: this.Quote.shippingData?.destinationItem?.destination };
                this.Quote.shippingData.destinationItem.destination = _destinationItem;
                this.Validate.destination = false;
            } else if (this.Quote.shippingData?.destinationItem?.destination === null || this.Quote.shippingData?.destinationItem?.destination?.eValue === '') {
                this.Quote.shippingData.destinationItem.destination = null;
                this.Validate.destination = true;
                isInValidate = true;
            } else {
                this.Validate.destination = false;
            }


            if (this.Quote.shippingData.originItem.originPickupService === true) {
                if (this.Quote?.shippingData?.originItem?.country != null && typeof this.Quote.shippingData.originItem.country?.eValue === 'undefined') {
                    // const _originItemCountry = { eName: this.Quote?.shippingData?.originItem?.country, eValue: this.Quote?.shippingData?.originItem?.country };
                    // this.Quote.shippingData.originItem.country = _originItemCountry;
                    // this.Validate.OriginCountry = false;
                    this.Quote.shippingData.originItem.country = null;
                    this.Validate.OriginCountry = true;
                } else if (this.Quote.shippingData.originItem.country === null || this.Quote.shippingData.originItem.country?.eValue === '') {
                    this.Quote.shippingData.originItem.country = null;
                    this.Validate.OriginCountry = true;
                    isInValidate = true;
                } else {
                    this.Validate.OriginCountry = false;
                }

                if (this.Quote?.shippingData?.originItem?.city != null && typeof this.Quote?.shippingData?.originItem?.city?.eValue === 'undefined') {
                    const _originItemCity = { eName: this.Quote?.shippingData?.originItem?.city, eValue: this.Quote?.shippingData?.originItem?.city };
                    this.Quote.shippingData.originItem.city = _originItemCity;
                } else if (this.Quote?.shippingData?.originItem?.city === null || this.Quote?.shippingData?.originItem?.city?.eValue === '') {
                    this.Quote.shippingData.originItem.city = null;
                    this.Validate.OriginCity = true;
                    isInValidate = true;
                } else {
                    this.Validate.OriginCity = false;
                }

                if (this.Quote.shippingData.originItem === '' || this.Quote.shippingData.originItem.zipCode === '') {
                    this.Validate.OriginZipCode = true;
                    isInValidate = true;
                } else {
                    this.Validate.OriginZipCode = false;
                }
                if (this.Quote.shippingData.originItem.address === '') {
                    this.Validate.OriginAddress = true;
                    isInValidate = true;
                } else {
                    this.Validate.OriginAddress = false;

                }

            }

            if (this.Quote.shippingData.destinationItem.destinationDeliveryService === true) {

                if (this.Quote?.shippingData?.destinationItem?.country != null && typeof this.Quote?.shippingData?.destinationItem?.country?.eValue === 'undefined') {
                    // const _destinationItemCountry = { eName: this.Quote?.shippingData?.destinationItem?.country, eValue: this.Quote?.shippingData?.destinationItem?.country };
                    // this.Quote.shippingData.destinationItem.country = _destinationItemCountry;
                    // this.Validate.destinationCountry = false;
                    this.Quote.shippingData.destinationItem.country = null;
                    this.Validate.destinationCountry = true;
                    isInValidate = true;
                } else if (this.Quote?.shippingData?.destinationItem?.country === null || this.Quote?.shippingData?.destinationItem?.country === '' || this.Quote?.shippingData?.destinationItem?.country?.eValue === '') {
                    this.Quote.shippingData.destinationItem.country = null;
                    this.Validate.destinationCountry = true;
                    isInValidate = true;
                } else {
                    this.Validate.destinationCountry = false;
                }

                if (this.Quote?.shippingData?.destinationItem?.city != null && typeof this.Quote?.shippingData?.destinationItem?.city?.eValue === 'undefined') {
                    const _destinationItemCity = { eName: this.Quote?.shippingData?.destinationItem?.city, eValue: this.Quote?.shippingData?.destinationItem?.city };
                    this.Quote.shippingData.destinationItem.city = _destinationItemCity;
                    this.Validate.destinationCity = false;
                } else if (this.Quote?.shippingData?.destinationItem?.city === null || this.Quote?.shippingData?.destinationItem?.city === '' || this.Quote?.shippingData?.destinationItem?.city?.eValue === '') {
                    this.Quote.shippingData.destinationItem.city = null;
                    this.Validate.destinationCity = true;
                    isInValidate = true;
                } else {
                    this.Validate.destinationCity = false;
                }

                if (this.Quote.shippingData.destinationItem.zipCode === '') {
                    this.Validate.destinationZipCode = true;
                    isInValidate = true;
                } else {
                    this.Validate.destinationZipCode = false;

                }

                if (this.Quote.shippingData.destinationItem.address === '') {
                    this.Validate.destinationAddress = true;
                    isInValidate = true;
                } else {
                    this.Validate.destinationAddress = false;

                }
            }
            
            if(!this.isMyDimerco){
                if (this.Quote.contactInformation.firstName === '') {
                    this.Validate.firstName = true;
                    isInValidate = true;
                } else {
                    this.Validate.firstName = false;
                }
                if (this.Quote.contactInformation.lastName === '') {
                    this.Validate.lastName = true;
                    isInValidate = true;
                } else {
                    this.Validate.lastName = false;
                }
                if (this.Quote.contactInformation.companyName === '') {
                    this.Validate.companyName = true;
                    isInValidate = true;
                } else {
                    this.Validate.companyName = false;
                }
                if (this.Quote.contactInformation.businessemail === '') {
                    this.Validate.businessMail = true;
                    isInValidate = true;
                } else {
                    this.Validate.businessMail = !this.textValidateEmail(this.Quote.contactInformation.businessemail);
                    if(this.Validate.businessMail)
                        isInValidate = true;
                }
                if(this.Quote.contactInformation.isDimercoCustomer === '1'){
                    if (this.Quote.contactInformation.salseEmail != '') {
                        this.Validate.salseEmail = !this.textValidateEmail(this.Quote.contactInformation.salseEmail);
                        if(this.Validate.salseEmail)
                            isInValidate = true;
                    }else
                        this.Validate.salseEmail = false;
                }

            
                //add by Wilson @ 20230818 VAL-12551 add check if country is null mapping            
                if (this.Quote?.contactInformation?.country != null && typeof this.Quote?.contactInformation?.country?.eValue === 'undefined') {
                    // const _contactInformationCountry = { eName: this.Quote?.contactInformation?.country, eValue: this.Quote?.contactInformation?.country };
                    // this.Quote.contactInformation.country = _contactInformationCountry;
                    // this.Validate.contactCountry = false;
                    this.Quote.contactInformation.country = null;
                    this.Validate.contactCountry = true;
                } else if (this.Quote?.contactInformation?.country === null || this.Quote?.contactInformation?.country === '' || this.Quote?.contactInformation?.country?.eValue === '') {
                    this.Quote.contactInformation.country = null;
                    this.Validate.contactCountry = true;
                    isInValidate = true;
                } else {
                    this.Validate.contactCountry = false;
                }
            
                if (this.Quote?.contactInformation?.city != null && typeof this.Quote?.contactInformation?.city?.eValue === 'undefined') {
                    const _contactInformationCity = { eName: this.Quote?.contactInformation?.city, eValue: this.Quote?.contactInformation?.city };
                    this.Quote.contactInformation.city = _contactInformationCity;
                    this.Validate.contactCity = false;
                } else if (this.Quote?.contactInformation?.city === null || this.Quote?.contactInformation?.city === '' || this.Quote?.contactInformation?.city?.eValue === '') {
                    this.Quote.contactInformation.city = null;
                    this.Validate.contactCity = true;
                    isInValidate = true;
                } else {
                    this.Validate.contactCity = false;
                }
            
                if (this.Quote?.contactInformation?.phoneCode != null && typeof this.Quote?.contactInformation?.phoneCode?.eValue === 'undefined') {
                    // const _contactInformationPhoneCode = { eName: this.Quote?.contactInformation?.phoneCode, eValue: this.Quote?.contactInformation?.phoneCode };
                    this.Quote.contactInformation.phoneCode = null;
                }
            
                if (this.Quote.contactInformation.zipCode === '') {
                    this.Validate.contactZipCode = true;
                    isInValidate = true;
                } else {
                    this.Validate.contactZipCode = false;
                }
                if (this.Quote.contactInformation.address === '') {
                    this.Validate.contactAddress = true;
                    isInValidate = true;
                } else {
                    this.Validate.contactAddress = false;
                }
                if (this.Quote.contactInformation.hearAboutUS === '') {
                    this.Validate.whereKnowDimercoFrom = true;
                    isInValidate = true;
                } else {
                    this.Validate.whereKnowDimercoFrom = false;
                }
            }

            if (this.Quote.servicePackage.dangerousNFlammableCargo.selected &&
                this.Quote.servicePackage.dangerousNFlammableCargo.Files_Dangerous.Files === null
            ) {
                this.Validate.dangerousNFlammableCargo = true;
                isInValidate = true;
            } else {
                this.Validate.dangerousNFlammableCargo = false;
            }
            if (isInValidate) {
                this.showSubmit = false;
                return;
            }
        },
        CargoFileUpload(event) {
            this.pushFiletoResult(event.files, 'CargoDetail');
        },
        CBrokerageFileUpload(event) {
            this.pushFiletoResult(event.files, 'CBrokerageFileUpload');
        },
        DNFCargoFileUpload(event) {
            this.pushFiletoResult(event.files, 'DNFCargoFileUpload');
        },
        pushFiletoResult(files, UploadType) {
            let fileList = [];
            files.forEach((file) => {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = function () {
                    let base64data = reader.result;
                    var fileItem = {
                        DocType: '0',
                        FileFormat: file.type,
                        FileName: file.name,
                        DisplayName: file.name,
                        FileContent: base64data,
                        FileUri: null,
                    };
                    fileList.push(fileItem);
                };
            });
            if (UploadType === 'CargoDetail') {
                this.Quote.Files_Cargo.Files = fileList;
            }
            if (UploadType === 'CBrokerageFileUpload') {
                this.Quote.servicePackage.customsBrokerage.Files_Brokerage.Files = fileList;
            }
            if (UploadType === 'DNFCargoFileUpload') {
                this.Quote.servicePackage.dangerousNFlammableCargo.Files_Dangerous.Files = fileList;
                this.checkRequired();
            }
        },
        closeModal() {
            this.displayModal = false;
            //Update By Wilson @ VAL-14271 change reload page solution
            window.location.reload();
            // this.$router.go(0);
        },
        numberToCurrencyNo(value) {
            if (!value) return 0;
            const intPart = Math.trunc(value);
            const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            let floatPart = '';
            const valueArray = value.toString().split('.');
            if (valueArray.length === 2) {
                floatPart = valueArray[1].toString();
                return intPartFormat + '.' + floatPart;
            }
            return intPartFormat + floatPart;
        },
        changeCargoDetailCubicUOM(event) {
            this.Quote.CargoDetailList.forEach((item) => {
                item.unit = { eName: event.value, eValue: event.value }
            });
            this.displayText.cargoDetailSubTotalCubicUOM = event.value === 'CM' ? "CBM" : "CUFT";
            this.displayText.totalCBMText = event.value === 'CM' ? "CBM" : "CUFT";
            this.recalculateAll();
        },
        changeCargoDetailVolumnUOM(event) {
            this.Quote.CargoDetailList.forEach((item) => {
                item.weightPreUnit = { eName: event.value, eValue: event.value }
            });
            this.displayText.cargoDetailSubTotalVolumeUOM = event.value;
            this.displayText.totalVolumnText = event.value;
            this.recalculateAll();
        },
        changeCargoDetailTotalCubicUOM(event) {
            this.displayText.totalCBMText = event.value;
            this.recalculateAll();
        },
        changeCargoDetailTotalVolumnUOM(event) {
            this.displayText.totalVolumnText = event.value;
            this.recalculateAll();
        },
        CargoFileRemove(UploadTypes) {
            switch (UploadTypes) {
                case "CargoDetail":
                    this.Quote.Files_Cargo.Files = null;
                    break;
                case "CBrokerage":
                    this.Quote.servicePackage.customsBrokerage.Files_Brokerage.Files = null;
                    break;
                case "DNFCargo":
                    this.Quote.servicePackage.dangerousNFlammableCargo.Files_Dangerous.Files = null;
                    break;
            }

            this.checkRequired();
        },
        setSelectDate(val) {
            this.Quote.cargoReadyDate = val;
            this.checkRequired();
        },
        generateRandomFilename() {
            const randomString = this.generateRandomString(6);
            const currentTimestamp = moment(new Date()).format(
                "MM_DD_YYYY_h_mm_ss_SSS"
            );
            const randomNumber = Math.floor(Math.random() * 1000000);
            const fileExtension = "";
            this.generatedRandomFilename =
                randomString +
                "_" +
                currentTimestamp +
                "_" +
                randomNumber +
                fileExtension;
        },
        generateRandomString(stringLength) {
            let result = "";
            const alphaNumericCharacters =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            const alphabetsLength = alphaNumericCharacters.length;
            for (let i = 0; i < stringLength; i++) {
                result += alphaNumericCharacters.charAt(Math.floor(Math.random() * alphabetsLength));
            }
            return result;
        },
        hubspothsq() {
            var _hsq = window._hsq = window._hsq || [];
            _hsq.push(['setPath', '/#']);
            _hsq.push(['setPath', '/#/getaquote']);
            _hsq.push(['trackPageView']);
        },
        textValidateEmail(email){
            let isCheckPass = true;
            const callback = (error) => {
                if (error) {
                    isCheckPass = false;
                }

            };
            validateEmail(null, email, callback);
            return isCheckPass;
        }
    },
    beforeUnmount() {
        let hubspotscript = document.getElementById('hs-script-loader')
        if (hubspotscript.parentNode) {
            hubspotscript.parentNode.removeChild(hubspotscript);
        }
    }
};
</script>

<style scoped lang="scss">
#page-container {
    position: relative;
    min-height: 100vh;
}

#content-wrap {
    padding-bottom: 2.5rem;
    /* Footer height */
}

#footer {
    padding: 8px 8px 16px 8px;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 4.5rem;
    /* Footer height */
    box-shadow: 0-10px;
    box-sizing: border-box;
    display: block;
    color: #011837;
    z-index: 2000;
    padding-top: 22px;
    background-color: #fff;
    text-align: end;
}

#header-wrap {
    background-color: #fff !important;
}

#content-wrap {
    max-width: 1024px;
    margin-left: auto;
    margin-right: auto;
    padding: 16px 16px 16px 16px;
    margin-bottom: 1rem;
}

.subTitle1 {
    letter-spacing: 0;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-bottom: 16px;
    color: #000 !important;
    margin: 0 0 16px;
}

.subTitle2 {
    letter-spacing: 0;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-bottom: 16px;
    color: #ff9800 !important;
    margin: 0 0 16px;
}

.selectModeDescription {
    color: #8b95a0 !important;
}

::v-deep(.p-card) {
    padding: 16px 24px;
    margin-bottom: 48px;
    width: 100%;
}

.SubjectLable {
    font-size: 26px;
    line-height: 40px;
    margin-bottom: 16px;
    font-weight: bold;
    letter-spacing: 0;
    direction: ltr;
    text-size-adjust: 100%;
}

.shipmentTypeButton {
    width: 5rem;
    border: 1px solid #025984;
    color: #025984 !important;
    background-color: #fff !important;
}

.shipmentTypeButtonSelected {
    width: 5rem;
    border: 1px solid #025984;
    background-color: #025984 !important;
}

::v-deep(.p-fileupload-content) {
    padding-top: 2px;
    padding-bottom: 2px;

    .p-fileupload-row>div {
        padding: 0px;
    }

    button {
        padding: 0px;
    }

    .p-fileupload-row {
        height: 1.7rem;
    }
}

::v-deep(.p-fileupload-row) {
    div:nth-child(1) {
        display: none;
    }

    div:nth-child(3) {
        display: none;
    }

    div:nth-child(4) {
        display: none;
    }
}

::v-deep(.p-fileupload) {
    width: 50%;
}

.inValidate {
    color: red;
    font-weight: bold;
}</style>